import React, { useEffect, useState } from 'react';
import { Popover as HLPopover, Transition } from '@headlessui/react';
import usePopoverContext from './usePopoverContext';
import tw from 'twin.macro';
import { css } from '@emotion/react';
import PortalWrapper from '@teetsh/app/src/components/PortalWrapper';

interface Props {
  children: React.ReactNode;
  size?: '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'auto';
  overflow?: 'hidden' | 'visible';
  onOpen?: () => void;
  onClose?: () => void;
  disableMargins?: boolean;
}

const sizeToWidth = {
  sm: tw`w-52`,
  md: tw`w-64`,
  lg: tw`w-72`,
  xl: tw`w-80`,
  '2xl': tw`md:w-96`,
  auto: tw`w-auto`,
};

export const panelPopoverStyle = [
  tw`origin-top-right bg-white divide-y rounded-lg focus:outline-none z-50`,
  css`
    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2),
      0 8px 24px rgba(16, 22, 26, 0.2);
  `,
];

export default function PopoverPanel(props: Props) {
  const { children, size = 'md', overflow = 'hidden', disableMargins } = props;
  const { portal, open, refs, floatingStyles } = usePopoverContext();

  const [showBar, setShowBar] = useState<boolean | undefined>(false);

  useEffect(() => {
    setShowBar(open);
  }, [open]);

  if (!open) {
    return null;
  }
  return (
    <PortalWrapper portal={portal}>
      <div
        tw="max-w-full"
        ref={refs.setFloating}
        style={{ ...floatingStyles, zIndex: 50 }}
      >
        <Transition
          show={showBar}
          enter="menuEnter"
          enterFrom="menuEnterFrom"
          enterTo="menuEnterTo"
          leave="menuLeave"
          leaveFrom="menuLeaveFrom"
          leaveTo="menuLeaveTo"
          beforeEnter={() => {
            if (props.onOpen) {
              props.onOpen();
            }
          }}
        >
          <HLPopover.Panel
            static
            css={[
              ...panelPopoverStyle,
              overflow === 'hidden' && tw`overflow-hidden`,
              overflow === 'visible' && tw`overflow-visible`,
              sizeToWidth[size],
              // J'ai ajouté disableMargins car si je positionne en bottom-end, ou bottom-start ça ne s'alligne
              // pas avec le bouton... à voir si faudrait pas virer ce mx-2
              !disableMargins && tw`mx-2`, // prevents touching the edges of the screen on mobile
            ]}
          >
            {children}
          </HLPopover.Panel>
        </Transition>
      </div>
    </PortalWrapper>
  );
}
